// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__HVLlR","info":"styles_info__Hqzzc","container_s":"styles_container_s__SCBdM"};